import { NULL_LOGGER } from "@thi.ng/api";
export var State;
(function (State) {
    State[State["IDLE"] = 0] = "IDLE";
    State[State["ACTIVE"] = 1] = "ACTIVE";
    State[State["DONE"] = 2] = "DONE";
    State[State["ERROR"] = 3] = "ERROR";
    State[State["DISABLED"] = 4] = "DISABLED"; // TODO currently unused
})(State || (State = {}));
/**
 * Closing behavior for `StreamMerge` and `StreamSync`.
 */
export var CloseMode;
(function (CloseMode) {
    CloseMode[CloseMode["NEVER"] = 0] = "NEVER";
    CloseMode[CloseMode["FIRST"] = 1] = "FIRST";
    CloseMode[CloseMode["LAST"] = 2] = "LAST";
})(CloseMode || (CloseMode = {}));
export let LOGGER = NULL_LOGGER;
export const setLogger = (logger) => (LOGGER = logger);
